/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { trackUploadStatusSchema } from "./trackUploadStatusSchema.ts";
import { z } from "zod";

export const jingleModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор связки"),
"trackId": z.string().uuid().describe("Идентификатор джингла"),
"name": z.string().describe("Наименование трека"),
"number": z.number().int().describe("Порядковый номер"),
"uploadStatus": z.lazy(() => trackUploadStatusSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n"),
"files": z.array(z.lazy(() => fileModelSchema)).describe("Файлы")
    })